import { ODDS_VIEW } from "../constants";
import { SELECT_FAVOURITE } from "../constants/actions";
import { ALL, DESELECT, FAVOURITES } from "../constants/analytics";
import { sendAnalyticsEvent } from "../lib/postMessage";

// Select a favourite and update filter state
export const selectFavouriteAndUpdateFilter = (favourite) => (dispatch) => {
  // First, update favourites reducer
  dispatch({
    type: SELECT_FAVOURITE,
    payload: favourite.id,
  });

  // Then, update filter reducer with the selected favourite data
  dispatch({
    type: "UPDATE_FILTER_FROM_FAVOURITE",
    payload: {
      odds:
        favourite?.odds && Object.keys(favourite?.odds).length > 0
          ? favourite.odds
          : {
              minOdds: null,
              maxOdds: null,
              isDecimal: false,
            },
      markets:
        favourite.markets && favourite.markets.length > 0
          ? favourite.markets
          : [],
    },
  });
};

// Clear favourite selection and reset filter
export const clearFavouriteAndResetFilter = () => (dispatch) => {
  dispatch({
    type: SELECT_FAVOURITE,
    payload: "",
  });
  dispatch({
    type: "RESET_FILTER_FROM_FAVOURITE",
  });
};

export const selectOddsAndUpdateFavourites = (odds) => (dispatch) => {
  dispatch({
    type: "ADD_FAVOURITE_ODDS_SELECTION",
    payload: {
      filter: ODDS_VIEW,
      selection: {
        minOdds: odds.minOdds,
        maxOdds: odds.maxOdds,
        isDecimal: true,
      },
    },
  });
};

export const removeOddsAndUpdateFavourites = (label) => (dispatch) => {
  dispatch({
    type: "REMOVE_FAVOURITE_ODDS_SELECTION",
  });

  sendAnalyticsEvent({
    event: FAVOURITES,
    type: ALL,
    action: DESELECT,
    value: label,
  });
};
